import {ActionCompletionDialogComponent} from '../../common/action-completion-dialog/action-completion-dialog.component';
import {CommonService} from '../../services/common.service';
import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {ConfirmActionDialogComponent} from '../../common/confirm-action-dialog/confirm-action-dialog.component';
import {LoadingService} from '../../services/loading.service';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import {PurchaseOrdersService} from '../../services/purchase-orders.service';
import {SelectionModel} from '@angular/cdk/collections';

import UsersConfig from '../../table/configs/users.json';

@Component({
  templateUrl: './assign-request.component.html'
})
export class AssignRequestComponent implements OnInit {
  public usersConfig: any;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;

  public dataSource: MatTableDataSource<any>;
  public displayedColumns: string[];
  public selection: SelectionModel<any>;
  public requestId: string;
  public typeId: number;
  public userRouted: number;
  public tableHeight: number;
  public tableContainerHeight: number;

  constructor(private commonService: CommonService,
              private loadingService: LoadingService,
              private matDialog: MatDialog,
              private matDialogRef: MatDialogRef<AssignRequestComponent>,
              private purchaseOrdersService: PurchaseOrdersService,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    this.tableContainerHeight = window.innerHeight - 400;
    this.tableHeight = window.innerHeight - 400;
    this.requestId = this.data.requestId;
    this.typeId = this.data.typeId;
    this.userRouted = this.data.userRouted;
    this.usersConfig = JSON.parse(JSON.stringify(UsersConfig));

    this.dataSource = new MatTableDataSource<any>(this.data.users);

    this.displayedColumns = ['select', 'name', 'role_name', 'status_name'];

    this.selection = new SelectionModel<any>(true, []);

    this.matDialogRef.updateSize('500');
  }

  public ngOnInit(): void {
    this.usersConfig.filter = `role_id = 14`;
    this.dataSource.paginator = this.commonService.setPaginatorTexts(this.paginator);
    this.dataSource.sort = this.sort;

    this.dataSource.data.forEach((row) => {
      if (row.id === this.userRouted) {
        this.selection.select(row);
      }
    });
  }

  public applyFilter(filterValue: string): void {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  public closeDialog(): void {
    this.matDialogRef.close();
  }

  public isAllSelected(): boolean {
    const numSelected = this.selection.selected.length;

    // @ts-ignore
    const numRows = this.dataSource.data.length;

    return numSelected === numRows;
  }

  public masterToggle(): void {
    // @ts-ignore
    this.isAllSelected() ? this.selection.clear() : this.dataSource.data.forEach((row) => this.selection.select(row));
  }

  isFormValid(): boolean {
    return this.selection.selected.length === 0;
  }

  submitAssignment() {

  }

  public async assignCommandToUser(object: any): Promise<void> {
    try {
      const model = {
        recipient_sale_point_id: object.salePointId,
        recipient_user_id: object.userId
      };

      await this.purchaseOrdersService.updateReceiptCommand(`return_command/web/routing/${object.commandId}`,
        model);
      this.matDialog.open(ActionCompletionDialogComponent, {
        data: {
          buttonText: 'Πλοήγηση στις επιστροφές ψυγείων',
          redirectURL: `returns`
        }
      });
    } catch (e) {
    }
  }

  public async confirmAssignment(): Promise<any> {
    // this.loadingService.show();
    let filter = '';
    if (this.typeId === 5) {
      filter = `user_id=${this.selection.selected[0].id} AND (category_id = 2 OR category_id = 3)`;
    } else {
      filter = `user_id=${this.selection.selected[0].id} AND category_id = 2`;
    }

    const salePoint = await this.purchaseOrdersService.getList('sale_point/single', filter);
    this.loadingService.hide();
    const objectToSend = {salePointId: salePoint.id, commandId: this.requestId, userId: this.selection.selected[0].id};
    const dialog = this.matDialog.open(ConfirmActionDialogComponent, {
      data: {
        confirmFunction: async () => {
          await this.assignCommandToUser(objectToSend);
        },
        message: `Είστε σίγουροι ότι θέλετε να αναθέσετε ως παραλήπτη: ${salePoint.customer_name}  για την εντολή επιστροφής με αριθμό : ${this.requestId}?`,
        title: 'Ανάθεση εντολής'
      }
    });
    dialog.afterClosed().subscribe(() => {
      this.closeDialog();
    });
  }


  selectRow(row: any) {
    this.selection.clear();
  }

  selectRow1(row: any) {
    const oldSelected = this.selection.selected;
    if (oldSelected.length > 0) {
      this.selection.clear();
      this.selection.toggle(row);
    }
    if (oldSelected[0] === row || oldSelected.length === 0) {
      this.selection.toggle(row);
    }
  }
}
